(
  () => {
    'use strict';
    function e(e = document.body, t = 'js-') {
      const a = [
        ...e.querySelectorAll(t ? `[class*="${ t }"]` : '*')
      ],
      n = t ? 'classList' : 'dataset';
      return a.reduce(
        (
          (e, a) => (
            [].slice.call(t ? a[n] : Object.entries(a[n])).forEach(
              (
                n => {
                  let o;
                  t &&
                  n.slice(0, t.length) === t ? o = n.slice(t.length, n.length) : t ||
                  ([o] = n),
                  o &&
                  (
                    e[o] = e.hasOwnProperty(o) ? e[o].constructor === Array ? e[o].concat(a) : [
                      e[o],
                      a
                    ] : a
                  )
                }
              )
            ),
            e
          )
        ),
        {
        }
      )
    }
    function t(e, t = window.Phill.money_format) {
      'string' == typeof e &&
      (e = e.replace('.', ''));
      let a = '';
      const n = /\{\{\s*(\w+)\s*\}\}/;
      function o(e, t, a, n) {
        if (
          void 0 === t &&
          (t = 2),
          n = ',' == (a = window.Phill.money_separator) ? '.' : ',',
          isNaN(e) ||
          null == e
        ) return 0;
        const o = (e = (e / 100).toFixed(t)).split('.');
        return o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + a) + (o[1] ? n + o[1] : '')
      }
      switch (t.match(n) [1]) {
        case 'amount':
        case 'amount_with_comma_separator':
        case 'amount_with_space_separator':
          a = o(e, 2);
          break;
        case 'amount_no_decimals':
        case 'amount_no_decimals_with_comma_separator':
        case 'amount_no_decimals_with_space_separator':
          a = o(e, 0)
      }
      return t.replace(n, a)
    }
    const a = window.component(
      (
        (a, n) => {
          const {
            currentVariantTitle: o,
            currentVariantSku: i,
            altColorSwatch: r,
            altColorSwatchWrapper: c,
            altColorSwatchContainer: s,
            normalAtcButton: d,
            floatingAtcBanner: l
          }
          = e(a, null),
          u = function (e, t) {
            t = {
              select: '[data-option-select]',
              radio: '[data-option-radio]',
              main: '[data-option-main]',
              ...t
            };
            const a = [],
            n = {
              id: null,
              options: []
            },
            o = document.querySelectorAll(t.select),
            i = document.querySelectorAll(t.radio),
            r = document.querySelector(t.main);
            if (!r || !r.length) throw 'data-option-main is missing';
            if (i.length > 3) throw 'you have more than three radio groups';
            if (o.length > 3) throw 'you have more than three select inputs';
            const c = [].slice.call(r.children).reduce(((e, t) => (e[t.innerHTML] = t.value, e)), {
            });
            function s() {
              n.id = c[n.options.join(' / ')],
              r.value = n.id;
              for (const e of a) e(n)
            }
            return o.forEach(
              (
                e => {
                  if ('SELECT' !== e.nodeName) throw 'data-option-select should be defined on the individual option selectors';
                  const t = Number(e.getAttribute('data-index'));
                  n.options[t] = e.value,
                  e.addEventListener('change', (e => {
                    n.options[t] = e.target.value,
                    s()
                  }))
                }
              )
            ),
            i.forEach(
              (
                e => {
                  if ('INPUT' === e.nodeName) throw 'data-option-radio should be defined on a parent of the radio group, not the inputs themselves';
                  const t = Number(e.getAttribute('data-index')),
                  a = [].slice.call(e.getElementsByTagName('input'));
                  a.forEach((e => {
                    e.checked &&
                    (n.options[t] = e.value);
                  })),
                  function (e, a) {
                    e.map(
                      (
                        e => e.onclick = e => {
                          return a = e.target.value,
                          n.options[t] = a,
                          void s();
                          var a
                        }
                      )
                    );
                  }(a)                  
                }
              )
            ),
            s(),
            {
              get state() {
                return n
              },
              onUpdate: e => (a.indexOf(e) < 0 && a.push(e), () => a.splice(a.indexOf(e), 1))
            }
          }(),
          {
            product: {
              variants: h
            },
            selectedOrFirstAvailableVariant: p
          }
          = JSON.parse(document.querySelector('.js-product-json').innerHTML),
          m = [].concat(r),
          w = e => {
            if (typeof e === 'string') {
              e=e.replace(' ', '-');
              e=e.replace(' ', '-');
            }
            let x = m.find((z => z.dataset.inputId == e));
            if (x) e=x;
            m.forEach((e => e.classList.remove('color-active'))),
            e && e.classList.add('color-active')            
          };
          m.forEach(
            (
              e => {
                e.addEventListener(
                  'click',
                  (
                    () => {
                      if (
                        c.style.height = '' === c.style.height ? `${ s.scrollHeight }px` : '',
                        e.classList.contains('color-active')
                      ) return;
                      w(e);
                      const {
                        inputId: t
                      }
                      = e.dataset;
                      document.getElementById(t).click()
                    }
                  )
                )
              }
            )
          );
          let f = h.find((e => e.id === p)) ||
          h.find((e => e.available)) ||
          h[0];
          n.emit('variant:change', null, f);
          const v = {
            rootMargin: `-${ document.getElementById('shopify-section-header').getBoundingClientRect().height }px 0px 0px 0px`,
            threshold: [
              0,
              1
            ]
          };
          console.log(d);
          new IntersectionObserver(
            (
              e => {
                const t = e[0];
                1 === t.intersectionRatio &&
                l.classList.add('lg:hidden'),
                0 === t.intersectionRatio &&
                l.classList.remove('lg:hidden')
              }
            ),
            v
          ).observe(d),
          u.onUpdate(
            (
              ({
                id: r
              }) => {
                let c = h.find((e => e.id === parseInt(r, 10)));
                if (!c || f.id === c.id) {
                    if (!c) {
                      const color = u.state.options[0];
                      c = h.find((e => e.option1 == color));
                      r = c.id;
                    } else if (f.id === c.id) { return; }
                }
                let option = c.option1;
                
                let s = option.toLowerCase().replace(" ", "-") + "__radio";
                let variantTitle1 = c.title.split(" / ")[0];
                let variantTitle2 = c.title.split(" / ")[1];
                // console.log(s);
                w(s),
                [].concat(o).forEach((e => {
                  if (!e.attributes[2]) {
                    e.innerHTML = c.title
                  } else if (e.attributes[2].localName.includes("option-1")) {
                    e.innerHTML = variantTitle1;
                  } else if (e.attributes[2].localName.includes("option-2")) {
                    e.innerHTML = variantTitle2;
                  }
                })),
                [].concat(i).forEach((e => {
                  e.innerHTML = c.sku
                })),
                (
                  (a, n) => {
                    const {
                      price: o,
                      compareAtPrice: i
                    }
                    = e(n, null),
                    {
                      price: r,
                      compare_at_price: c
                    }
                    = a;
                    [].concat(o).forEach((e => {
                      e.innerHTML = t(r)
                    })),
                    i.innerHTML = c > r ? t(c) : ''
                  }
                ) (c, a),
                (
                  e => {
                    const t = new URL(window.location.href),
                    a = new URLSearchParams(t.search.slice(1));
                    e.forEach(
                      (
                        ({
                          name: e,
                          value: t
                        }) => {
                          '' !== t ? a.set(e, encodeURIComponent(t)) : a.delete(e)
                        }
                      )
                    ),
                    window.history.replaceState({
                    }, '', `${ window.location.pathname }?${ a.toString() }`)
                  }
                ) ([{
                  name: 'variant',
                  value: r
                }
                ]),
                n.emit('variant:change', null, c),
                f = c
              }
            )
          )
        }
      )
    );
    const n = (e, t = null) => {
      let a = e.split('.').reduce(((e, t) => e?.[t]), window?.Phill?.theme?.strings);
      return a ? (
        t &&
        (
          a = Object.entries(t).reduce(
            (
              (e, [
                t,
                a
              ]) => {
                const n = new RegExp(`\{{2}\s*(${ t })\s*\}{2}`, 'g');
                return e.replace(n, a)
              }
            ),
            a
          )
        ),
        a
      ) : `Missing translation for ${ e } in window.Phill`
    },
    o = window.component(
      (
        (t, a) => {
          const {
            openAccessoriesDrawer: o
          }
          = JSON.parse(document.querySelector('.js-product-json').innerHTML),
          {
            submit: i,
            stockIndicatorColor: r,
            stockIndicatorSpan: c,
            atcText: s,
            atcLoader: d
          }
          = e(t, null);
          let l = {};
          a.on(
            'variant:change',
            (
              (e, t) => {
                l = t,
                [].concat(r).forEach((e => {
                  e.classList[t.available ? 'remove' : 'add']('sold-out')
                })),
                [].concat(c).forEach(
                  (
                    e => {
                      e.textContent = n(t.available ? 'product.in_stock' : 'product.sold_out')
                    }
                  )
                ),
                [].concat(s).forEach(
                  (
                    e => {
                      e.textContent = n(t.available ? 'product.add_to_cart' : 'product.sold_out')
                    }
                  )
                ),
                [].concat(i).forEach((e => {
                  e.disabled = !t.available
                }))
              }
            )
          ),
          t.addEventListener(
            'submit',
            (
              async e => {
                e.preventDefault(),
                i.disabled = !0,
                [].concat(s).forEach((e => {
                  e.classList.add('invisible')
                })),
                [].concat(d).forEach((e => {
                              console.log(e),
                  e.classList.remove('hidden')
                })),
                await function (e, t, a = {}) {
                  return function (e = []) {
                    return window.app.emit('cart:updating'),
                    fetch(
                      `${ window.Phill.routes.cartAdd }.js`,
                      {
                        method: 'POST',
                        credentials: 'include',
                        headers: {
                          'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                          items: e
                        })
                      }
                    ).then((e => e.json())).then(
                      (
                        async e => {
                          if (e.status) return window.app.emit(['cart:updated',
                          'cart:error'], null, e),
                          {
                            item: e,
                            cart: window.app.getState().cart,
                            error: e?.description
                          };
                          const [t,
                          a] = await Promise.all(
                            [fetch(
                              `${ window.Phill.routes.cart }.js`,
                              {
                                method: 'GET',
                                credentials: 'include'
                              }
                            ).then((e => e.json())),
                            fetch(
                              `${ window.Phill.routes.cart }?sections=api-cart-items`,
                              {
                                method: 'GET',
                                credentials: 'include'
                              }
                            ).then((e => e.json()))]
                          );
                          return t.sections = a,
                          window.app.emit(['cart:updated',
                          'cart:render'], {
                            cart: t
                          }),
                          {
                            item: e,
                            cart: t
                          }
                        }
                      )
                    )
                  }([{
                    id: e.id,
                    quantity: t,
                    properties: a
                  }
                  ])
                }(l, t.elements.quantity.value).then(
                  (
                    ({
                      error: e
                    }) => {
                      e &&
                      alert(e),
                      i.disabled = !0,
                      [].concat(s).forEach((e => {
                        e.classList.remove('invisible')
                      })),
                      [].concat(d).forEach((e => {
                        e.classList.add('hidden')
                      })),
                      o ? setTimeout(
                        (() => {
                          e ||
                          a.emit('accessories-drawer:toggle', {
                            drawerOpen: !0
                          })
                        }),
                        0
                      ) : setTimeout((() => {
                        e ||
                        a.emit('cart:toggle', {
                          cartOpen: !0
                        })
                      }), 0),
                      setTimeout(
                        (
                          () => {
                            i.disabled = !1,
                            [].concat(s).forEach((e => {
                              e.classList.remove('invisible')
                            })),
                            [].concat(d).forEach((e => {
                              e.classList.add('hidden')
                            }))
                          }
                        ),
                        e ? 0 : 1000
                      )
                    }
                  )
                )
              }
            )
          )
        }
      )
    ),
    i = {
      productSelection: a,
      productForm: o,
      productImages: window.component(
        (
          async(t, a) => {
            const {
              imagesSlider: n,
              imageSlide: o,
              thumbnail: i,
              sliderNext: r,
              sliderPrev: c
            }
            = e(t, null),
            s = [].concat(i),
            d = [].concat(o);
            var l;
            await(
              l = 'Keen slider',
              new Promise(
                (
                  e => {
                    window?.hasLoaded?.scripts?.[l] ? e() : window.app.on(`${ l }:loaded`, e)
                  }
                )
              )
            );
            const u = {
              breakpoints: {
                '(min-width: 1024px)': {
                  slides: {
                    perView: 1
                  }
                }
              },
              slides: {
                perView: 1.2,
                spacing: 20
              },
              created(e) {
                d.forEach((e => e.classList.remove('mr-5')));
                const t = s.filter((e => !e.classList.contains('hidden')));
                t.forEach(
                  (
                    (a, n) => {
                      a.classList.remove('border-black'),
                      a.addEventListener('click', (() => {
                        e.moveToIdx(n)
                      })),
                      t[e.track.details.rel].classList.add('border-black')
                    }
                  )
                )
              },
              animationStarted(e) {
                (
                  e => {
                    const t = s.filter((e => !e.classList.contains('hidden')));
                    t.forEach((e => e.classList.remove('border-black'))),
                    t[e]?.classList.add('border-black')
                  }
                ) (e.animator.targetIdx || 0)
              }
            },
            h = () => {
              const e = new KeenSlider(n, u);
              r.addEventListener('click', (() => {
                e.next()
              })),
              c.addEventListener('click', (() => {
                e.prev()
              }));
              const t = () => {
                c.classList[0 === e.track.details.rel ? 'remove' : 'add']('lg:block'),
                r.classList[e.track.details.rel === e.slides.length - 1 ? 'remove' : 'add']('lg:block')
              };
              return t(),
              e.on('slideChanged', t),
              e
            };
            let p = h();
            a.on(
              'variant:change',
              (
                (e, t) => {
                  let a = t.option1.toLowerCase().replace(/ /g, '-');
                  if (t.option2) {
                    a += "-" + t.option2.toLowerCase().replace(/ /g, '-');
                  }
                  d.forEach(
                    (
                      e => {
                        e.dataset.imageAlt &&
                        (
                          e.dataset.imageAlt?.includes(a) ? (
                            e.classList.add('keen-slider__slide'),
                            e.classList.remove('hidden')
                          ) : (
                            e.classList.remove('keen-slider__slide'),
                            e.classList.add('hidden')
                          )
                        )
                      }
                    )
                  ),
                  s.forEach(
                    (
                      e => {
                        e.dataset.imageAlt &&
                        (
                          e.dataset.imageAlt?.includes(a) ? e.classList.remove('hidden') : e.classList.add('hidden')
                        )
                      }
                    )
                  ),
                  p.destroy(),
                  p = h()
                }
              )
            )
          }
        )
      )
    };
    window.app.add(i),
    window.app.mount()
  }
) ();